<template>
  <div class="content">
    <h4 class="mb-3" v-if="!modalData.readonly">
      {{ $t("Custom Filtering") }}
    </h4>
    <p class="mb-3" v-if="!modalData.readonly">
      {{
        $t(
          "Changes made to this content filter will only affect the current policy."
        )
      }}
    </p>
    <p class="mb-3" v-if="!modalData.readonly">
      {{
        $t(
          "Select the categories you want this content filter to BLOCK. Selected categories will be blocked"
        )
      }}
    </p>
    <label v-if="modalData.canSelectAlL" class="checkbox">
      <div class="custom-control custom-checkbox b-custom-control-lg">
        <input
          id="all"
          type="checkbox"
          class="custom-control-input"
          v-model="allSelected"
        /><label for="all" class="custom-control-label"></label>
      </div>
      <span>{{ allSelected ? $t("Un-select All") : $t("Select All") }} </span>
    </label>
    <form @submit.prevent="submit" autocomplete="off">
      <b-row>
        <b-col v-for="cat in categories" :key="cat.id" sm="12" md="6" lg="4">
          <label
            v-if="modalData.canSelectAlL"
            class="checkbox"
            :title="cat.description"
            ><div class="custom-control custom-checkbox b-custom-control-lg">
              <input
                :id="cat.id"
                type="checkbox"
                class="custom-control-input"
                v-model="cat.allowed"
              /><label :for="cat.id" class="custom-control-label"></label>
            </div>
            <span> {{ cat.name }}</span>
          </label>
          <span v-else>
            <t-checkbox
              v-model="cat.allowed"
              :data-test-id="`categories-${cat.name
                .toLowerCase()
                .replace(/\s/g, '-')}`"
              :id="cat.id.toString()"
              :label="cat.name"
              :value-true="false"
              :value-false="true"
              :disabled="modalData.readonly"
              :title="cat.description"
            />
          </span>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters("modal", ["modalData"]),
    ...mapGetters("categories", ["customerCategories"]),
    ...mapGetters("authentication", ["selectedUser", "mspId"]),
    allSelected: {
      get() {
        return this.categories.every((cat) => cat.allowed);
      },
      set(value) {
        this.categories.map((cat) => (cat.allowed = value));
      },
    },
    categories() {
      return this.modalData.categories || this.customerCategories;
    },
  },
  watch: {},
  methods: {
    ...mapMutations("modal", ["userAction", "showModal"]),
    ...mapActions("categories", ["updateCustomerSpecificCategory"]),
    ...mapActions("toast", ["displayToast"]),
    ...mapActions("customerPolicies", ["fetchCustomerPolicy"]),
    ...mapActions("defaultPolicy", ["updateDefaultFilteringPolicy"]),
    async submit() {
      try {
        /* istanbul ignore else */
        if (!this.modalData.readonly && !this.modalData.isMsp) {
          this.updateCustomerSpecificCategory({
            id: this.modalData.selectedUser || this.selectedUser.id,
            policyId: this.modalData.policy.id,
            categorySettings: this.customerCategories,
            tier: "user_id",
          });
          this.displayToast({
            title: this.$t("Success"),
            message: this.$t("Updated"),
            duration: 2000,
            variant: "success",
          });
        } else if (this.modalData.isMsp) {
          this.updateCustomerSpecificCategory({
            id: this.modalData.selectedUser || this.selectedUser.id,
            policyId: this.modalData.policy.id,
            categorySettings: this.customerCategories,
            tier: "msp_id",
          });
          this.displayToast({
            title: this.$t("Success"),
            message: this.$t("Updated"),
            duration: 2000,
            variant: "success",
          });
        } else {
          this.updateCustomerSpecificCategory({
            id: this.modalData.selectedUser || this.selectedUser.id,
            policyId: this.modalData.policy.id,
            categorySettings: this.customerCategories,
            tier: "default",
          });
        }
      } catch (e) {
        this.displayToast({
          title: this.$t("Error"),
          message: this.$t("Somethings not right, try again"),
          duration: 1000,
          variant: "error",
        });
      } finally {
        this.showModal(false);

        const reqData = {
          id: this.selectedUser.id,
          policyId: this.modalData.policy.id,
        };
        if (this.modalData.isMsp) {
          setTimeout(() => {
            this.updateDefaultFilteringPolicy({
              defaultPolicy: {
                safesearch: this.modalData.form.safesearch,
                allowunclassified: this.modalData.form.allowunclassified,
                level: "C",
              },
              mspId: this.mspId,
            });
          }, 1000);
        } else {
          setTimeout(() => {
            this.fetchCustomerPolicy(reqData);
          }, 1000);
        }
      }
    },
  },
  created() {
    this.userAction(this.submit);
  },
};
</script>
<style lang="scss" scoped>
.custom-control-input:checked ~ .custom-control-label:before {
  border-color: #00baa0;
  background-color: #00baa0;
}
.checkbox {
  display: flex;
  align-items: center;
  background-color: #f2f4f5;
  width: 100%;
  padding: 5px 10px;
  border-radius: 4px;
}
</style>
